var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolders(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.625 8.875V18.875H17.375V11.125H11.125C10.7464 11.125 10.3779 11.0022 10.075 10.775L7.54167 8.875H3.625ZM2.13756 7.38756C2.46575 7.05937 2.91087 6.875 3.375 6.875H7.625C8.00365 6.875 8.37208 6.99781 8.675 7.225L11.2083 9.125H17.625C18.0891 9.125 18.5342 9.30937 18.8624 9.63756C19.1906 9.96575 19.375 10.4109 19.375 10.875V19.2083C19.375 19.6504 19.1994 20.0743 18.8868 20.3868C18.5743 20.6994 18.1504 20.875 17.7083 20.875H3.375C2.91087 20.875 2.46575 20.6906 2.13756 20.3624C1.80937 20.0342 1.625 19.5891 1.625 19.125V8.625C1.625 8.16087 1.80937 7.71575 2.13756 7.38756Z",
    fill: "#080134"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.375 5.125V7.875C7.375 8.42728 6.92728 8.875 6.375 8.875C5.82272 8.875 5.375 8.42728 5.375 7.875V4.875C5.375 4.41087 5.55938 3.96575 5.88756 3.63756C6.21575 3.30938 6.66087 3.125 7.125 3.125H11.375C11.7536 3.125 12.1221 3.24781 12.425 3.475L14.9583 5.375H21.375C21.8391 5.375 22.2842 5.55937 22.6124 5.88756C22.9406 6.21575 23.125 6.66087 23.125 7.125V15.4583C23.125 15.9004 22.9494 16.3243 22.6368 16.6368C22.3243 16.9494 21.9004 17.125 21.4583 17.125H18.375C17.8227 17.125 17.375 16.6773 17.375 16.125C17.375 15.5727 17.8227 15.125 18.375 15.125H21.125V7.375H14.875C14.4964 7.375 14.1279 7.25219 13.825 7.025L11.2917 5.125H7.375Z",
    fill: "#080134"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolders);
export default __webpack_public_path__ + "static/media/folders.df82e6db.svg";
export { ForwardRef as ReactComponent };